import { LitElement, html, css } from 'lit';

class MetalyxContactModal extends LitElement {
  static properties = {
    open: { type: Boolean, reflect: true },
  };

  static styles = css`
    :host {
      display: none;
    }
    :host([open]) {
      display: block;
    }

    .overlay {
      position: fixed;
      inset: 0;
      background: rgba(10, 14, 26, 0.85);
      backdrop-filter: blur(8px);
      z-index: 300;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2rem;
    }

    .modal {
      background: var(--color-bg-secondary, #111827);
      border: 1px solid var(--color-border, rgba(255,255,255,0.06));
      border-radius: var(--radius-lg, 1rem);
      max-width: 500px;
      width: 100%;
      padding: 2.5rem;
      position: relative;
    }

    .close {
      position: absolute;
      top: 1rem;
      right: 1rem;
      background: none;
      border: none;
      color: var(--color-text-muted, #64748B);
      cursor: pointer;
      transition: color var(--transition, 200ms ease);
    }
    .close:hover {
      color: var(--color-text-heading, #fff);
    }

    h2 {
      font-family: var(--font-heading, 'Outfit', sans-serif);
      font-size: var(--text-2xl, 1.5rem);
      font-weight: 700;
      color: var(--color-text-heading, #fff);
      margin: 0 0 0.5rem;
    }

    .subtitle {
      color: var(--color-text-muted, #64748B);
      font-size: var(--text-sm, 0.875rem);
      margin-bottom: 1.5rem;
    }

    .field {
      margin-bottom: 1rem;
    }
    label {
      display: block;
      font-size: var(--text-sm, 0.875rem);
      font-weight: 500;
      color: var(--color-text-primary, #CBD5E1);
      margin-bottom: 0.35rem;
    }
    input, textarea {
      width: 100%;
      padding: 0.6rem 0.75rem;
      background: var(--color-bg-card, #1E293B);
      border: 1px solid var(--color-border, rgba(255,255,255,0.06));
      border-radius: var(--radius-sm, 0.375rem);
      color: var(--color-text-primary, #CBD5E1);
      font-family: var(--font-sans, 'DM Sans', sans-serif);
      font-size: var(--text-base, 1rem);
      transition: border-color var(--transition, 200ms ease);
    }
    input:focus, textarea:focus {
      outline: none;
      border-color: rgba(124, 58, 237, 0.5);
    }
    textarea {
      min-height: 100px;
      resize: vertical;
    }

    .submit-btn {
      display: inline-flex;
      align-items: center;
      padding: 0.7rem 1.5rem;
      border-radius: var(--radius-md, 0.75rem);
      background: var(--color-accent, #7C3AED);
      color: #fff;
      font-family: var(--font-sans, 'DM Sans', sans-serif);
      font-size: var(--text-base, 1rem);
      font-weight: 600;
      border: none;
      cursor: pointer;
      transition: all var(--transition, 200ms ease);
      margin-top: 0.5rem;
    }
    .submit-btn:hover {
      background: var(--color-accent-hover, #6D28D9);
      transform: translateY(-1px);
      box-shadow: 0 4px 20px rgba(124, 58, 237, 0.3);
    }
  `;

  constructor() {
    super();
    this.open = false;
    this._onKey = this._onKey.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('keydown', this._onKey);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('keydown', this._onKey);
  }

  _onKey(e) {
    if (e.key === 'Escape' && this.open) this._close();
  }

  _close() {
    this.dispatchEvent(new Event('close'));
  }

  _overlayClick(e) {
    if (e.target === e.currentTarget) this._close();
  }

  render() {
    return html`
      <div class="overlay" @click="${this._overlayClick}">
        <div class="modal">
          <button class="close" @click="${this._close}" aria-label="Close">
            <metalyx-icon name="close" size="24"></metalyx-icon>
          </button>
          <h2>Request a Demo</h2>
          <p class="subtitle">See how Metalyx can transform your mining operation.</p>
          <div class="field">
            <label>Name</label>
            <input type="text" placeholder="Your name" />
          </div>
          <div class="field">
            <label>Email</label>
            <input type="email" placeholder="your@email.com" />
          </div>
          <div class="field">
            <label>Company</label>
            <input type="text" placeholder="Company name" />
          </div>
          <div class="field">
            <label>Message</label>
            <textarea placeholder="Tell us about your operation..."></textarea>
          </div>
          <button class="submit-btn">Send Request</button>
        </div>
      </div>
    `;
  }
}

customElements.define('metalyx-contact-modal', MetalyxContactModal);